import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import MUIAppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from 'components/lowLevel/Logo';
import { useIsSideBarOpen } from 'utils/hooks/useIsSidebarOpen';
import useStyles from './AppBar.styles';

const AppBar = () => {
  const classes = useStyles();
  const [open, setIsOpen] = useIsSideBarOpen();

  const toggleOpen = () => {
    setIsOpen(!open);
  };

  return (
    <MUIAppBar className={classes.appBar} position="fixed">
      <Toolbar>
        <IconButton
          color="inherit"
          onClick={toggleOpen}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        <Logo />
      </Toolbar>
    </MUIAppBar>
  );
};

export default AppBar;
